import auth from '@/auth';
import wechat from '@/wechat';
import { WECHAT_GRANT, WECHAT_JSSDK, FETCH_WECHAT_USER, FETCH_WECHAT_TRAINER } from './types';

export default {
    [WECHAT_GRANT](state, payload) {
        state.token = payload.token;
        auth.setToken(payload.token);

        state.scope = payload.scope;
        wechat.setScope(payload.scope);
    },
    [WECHAT_JSSDK](state, payload) {
        state.jssdk = payload;
    },
    [FETCH_WECHAT_USER](state, payload) {
        state.wechat_user = payload;
    },
    [FETCH_WECHAT_TRAINER](state, payload) {
        state.trainer = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/wechat/mutations.js